// This is used to separate the ID from the name data
export const IDNameSeparator = '_';
